import { Col, Modal, Row } from 'antd';

import { ENV_VARS } from '@/env';

import { ReactComponent as CloseIcon } from '../../../assets/icons/x-close.svg';
import Button from '../Buttons/Button';
import IconButton from '../Buttons/IconButton';
import SvgConverter from '../Common/SvgConverter';

const isHalliburton = ENV_VARS.REACT_APP_THEME === 'halliburton';
const buttonClassname = isHalliburton ? 'hb-button' : '';

const HalWarningModal = ({
  open = false,
  okText,
  cancelText,
  onClose = () => {},
  onOk = () => {},
  okButtonVariant = 'primary',
  alertTitle,
  content,
  modalIcon,
}) => {
  const handleClose = () => {
    onClose();
  };

  const handleOk = () => {
    onOk();
  };

  return (
    <Modal
      rootClassName="common-root-bid-description-modal"
      className="common-bid-description-modal"
      closable={false}
      centered
      footer={false}
      open={open}
      style={{ zIndex: 1001 }}
    >
      <Row className="header-section" justify="space-between" align="middle">
        <Col>
          <Row className="wrapper">
            {modalIcon && <Col className="iconWrapper mr-15">{modalIcon}</Col>}
            <Col>{alertTitle}</Col>
          </Row>
        </Col>
        <Col className="lh-0">
          <IconButton onClick={handleClose}>
            <SvgConverter Icon={CloseIcon} color="white" width={24} height={24} />
          </IconButton>
        </Col>
      </Row>
      <div className="content-section">
        {content}
        <Row className="footer-section" justify="end">
          <Col>
            <Row gutter={12}>
              {okText && (
                <Col>
                  <Button variant={okButtonVariant} onClick={handleOk} className={`submit-btn ${buttonClassname}`}>
                    {okText}
                  </Button>
                </Col>
              )}
              {cancelText && (
                <Col>
                  <Button variant={okButtonVariant} onClick={handleClose} type="default" className="cancel-btn">
                    {cancelText}
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default HalWarningModal;
